import { graphql } from '@api/generated';
import { useQuery } from '@apollo/client/react';

export const GET_CUSTOMER_INFORMATION = graphql(`
  query getCustomerInformation($tenantId: ID!, $customerId: ID!) {
    customer(tenantId: $tenantId, id: $customerId) {
      type
      lifetimeRevenue
      outstandingBalance
      membership
    }
  }
`);

export const useCustomerInformation = (
  tenantId: string,
  customerId?: string,
) => {
  const { data, loading, error, refetch } = useQuery(GET_CUSTOMER_INFORMATION, {
    fetchPolicy: 'network-only',
    variables: { tenantId, customerId: customerId ?? '' },
    notifyOnNetworkStatusChange: true,
    skip: !customerId,
  });

  return { customerInformation: data?.customer, loading, error, refetch };
};
